import request from '@/helpers/request'

export default {
  async index() {
    return await request.get('information')
  },
  async show(id) {
    return await request.get(`information/${id}`)
  },
  async paginate(page) {
    return await request.get('information?page=' + page)
  },
  async infoUser() {
    return await request.get('info_user')
  },
  async paginateUser(page) {
    return await request.get('info_user?page=' + page)
  },
  async read(id) {
    return await request.get(`read_info/${id}`)
  }
}
